const DATA_TEST_IDS = {
  npiOrgNpiDataViewOrg: 'profile__npi-search-forms_npi-org_npi-data-view-org',
} as const;

export default DATA_TEST_IDS;
